import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';

export const serviceComputed = {
	...mapState('userManagementStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('userManagementStore', Object.keys(actions)),
	...mapMutations('userManagementStore', Object.keys(mutations))
};
